
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { appColors } from "@/config/globals";
import { useStore } from "vuex";
import useBreakpoints from "@/services/Breakpoints";

export default {
  async setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { type } = useBreakpoints();
    const program = computed(() => store.getters["user/program"]);
    const status = computed(() => store.getters["user/status"]);
    const colors = computed(() => {
      const eventData2 = store.getters["user/eventData"];
      if (eventData2.themeSettings) {
        if (eventData2.themeSettings.cardColor1) {
          const cardColor1 = eventData2.themeSettings.cardColor1;
          const cardColor2 = eventData2.themeSettings.cardColor2;
          const cardColor3 = eventData2.themeSettings.cardColor3;
          const cardColor4 = eventData2.themeSettings.cardColor4;
          const eventColors: Array<string> = [];
          for (let index = 0; index < 4; index++) {
            eventColors.push(cardColor1);
            eventColors.push(cardColor2);
            eventColors.push(cardColor3);
            eventColors.push(cardColor4);
          }
          return eventColors;
        }
        return appColors;
      }
      return appColors;
    });
    await store.dispatch("user/getProgramPreview", route.params.eventID);
    const goTo = (to) => {
      router.push({
        name: to,
        params: { eventID: route.params.eventID },
      });
    };
    function convertDate(date) {
      const newDate = new Date(date.seconds * 1000);
      const day = newDate.getDate();
      const month = newDate.getMonth() + 1;
      const year = newDate.getFullYear();
      return `${day}/${month}/${year}`;
    }
    await store.dispatch("user/getProgramPreview", route.params.eventID);
    return {
      goTo,
      colors,
      convertDate,
      program,
      status,
      type,
    };
  },
};
